





















import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import processdto from '@/store/entities/workorder/processworkorderpo';
import workorderActionEnum from '@/store/enums/workorderenum';



@Component({
    components: {},
})
export default class RescindWorkOrder extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    @Prop({ type: Number, default: 0 }) workorderId: number;
    entityDto: processdto = new processdto();
    loading: boolean = false;
    create() { }
    created() {

    }
    save() {
        (this.$refs.itemForm as any).validate(async (valid: boolean) => {
            if (valid) {
                this.loading = true;
                this.entityDto.actionId = workorderActionEnum.Rescind;
                let res = await this.$store
                    .dispatch({
                        type: "workorder/processWorkOrder",
                        data: this.entityDto,
                    })
                    .catch((err) => {
                        this.loading = false;
                        this.$Modal.info({
                            title: this.L("Tips"),
                            content: err,
                        });
                    });
                console.log(res)
                this.$Modal.info({
                    title: this.L("Tips"),
                    content: res.data.result,
                });
                this.loading = false;
                (this.$refs.itemForm as any).resetFields();
                this.$emit("save-success");
                this.$emit("input", false);
            }
        });
    }
    cancel() {
        (this.$refs.itemForm as any).resetFields();
        this.$emit("input", false);
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit("input", value);
        } else {
        }
    }
    itemRule = {
        processResult: [
            {
                required: true,
                message: this.L("FieldIsRequired"),
                trigger: "blur",
            },
        ],
    };
    @Watch("workorderId")
    getitemId() {
        this.entityDto.workId = this.workorderId;
    }
}
